import { db } from '@/main'
import AddOrderDialog from '@/components/add-order-dialog'
import RsvMsg from '@/components/rsv-msg'

export const Orders = {
  name: 'orders.viewable',

  components: {
    AddOrderDialog,
    RsvMsg
  },

  data() {
    return {
      message: '',
      month: new Date().getMonth(),
      human: {
        months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
        days: [ 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat' ]
      },
      date: new Date().getDate(),
      reservations: [],
      show: { rsv: false },
      merchant: {}, // account doc belonging to the owner/merchant of the business
    }
  },

  firestore() {
    if ( this.biz.id ) return {
      customers: {
        ref: db.collection('customers').where( 'business_id', '==', this.biz.id )
      },

      reservations: {
        ref: db.collection( 'reservations' ).where( 'business_id', '==', this.biz.id ),
        resolve: docs => {
          docs.sort( (d0, d1) => d0.datetime.start.toDate() - d1.datetime.start.toDate() )
          docs.forEach( d => db.collection( 'accounts' ).doc( d.account_id ).get().then( doc => {
            this.$set( d, 'account', doc.data() )
          }))
        }
      },

      services: db.collection('services').where( 'business_id', '==', this.biz.id ),
    }
  },

  watch: {
    biz( curr, prev ) {
      if ( curr && curr.id ) {
        this.$binding( 'reservations', db.collection( 'reservations' ).where( 'business_id', '==', curr.id )).then( docs =>
          docs.forEach( d => db.collection( 'accounts' ).doc( d.account_id ).get().then( doc => this.$set( d, 'account', doc.data() )))
        )
      }
    }
  },

  computed: {
    datetime() {
      let d = new Date()
      d.setHours( 0, 0, 0 )
      d.setMonth( this.month )
      d.setDate( this.date )
      return d
    },

    // srvs() {
    //   if ( !this.category_id ) return this.services
    //   else return this.services.filter( s => s.category_id == this.category_id )
    // },

    days() {
      return new Date( this.datetime.getFullYear(), this.datetime.getMonth() + 1, 0).getDate()
    },

    rsvs() {
      return this.reservations.filter( this.filter )
    }
  },

  methods: {
    notify(message) {
      this.message = message
    },

    filter(r) {
      return r.datetime.start.toDate().getDate() === this.datetime.getDate() &&
      r.datetime.start.toDate().getFullYear()    === this.datetime.getFullYear() &&
      r.datetime.start.toDate().getMonth()       === this.datetime.getMonth()
    }
  }
}
